import {FromageFacets} from './FromageFilterContent';

// Filtre les clés vides des facettes Orama (articles sans complements_produit)
function filterEmptyKeys(entries: [string, number][]): [string, number][] {
  return entries.filter(([key]) => key !== '');
}

// Construit les facettes fromage depuis les résultats Orama en excluant les clés vides
export function buildFromageFacets(
  facets: Record<string, {values: Record<string, number>} | undefined>,
): FromageFacets {
  return {
    famille_fromage: filterEmptyKeys(
      Object.entries(facets['famille_fromage']?.values ?? {}),
    ),
    type_de_lait: filterEmptyKeys(
      Object.entries(facets['type_de_lait']?.values ?? {}),
    ),
    traitement_thermique_du_lait: filterEmptyKeys(
      Object.entries(facets['traitement_thermique_du_lait']?.values ?? {}),
    ),
  };
}

// Vérifie si des facettes fromage existent pour savoir si le filtre doit être affiché
export function hasFromageFacets(facets: FromageFacets): boolean {
  return (
    facets.famille_fromage.length > 0 ||
    facets.type_de_lait.length > 0 ||
    facets.traitement_thermique_du_lait.length > 0
  );
}

// Compte total de sélections fromage actives
export function countFromageSelections(
  famille: string[],
  lait: string[],
  traitement: string[],
): number {
  return famille.length + lait.length + traitement.length;
}
